module.exports = __webpack_public_path__ + "static/media/happy-burger2.9a3ddf6b.png";